export default __webpack_public_path__ + "static/media/mirror.9935e9ff.jpg";